<template>
    <div :key="componentKey">
      <form-builder :treeStructure="tree" :level="1"></form-builder>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      tree: window.FormEngine.structure.tree as ITreeField,
      componentKey: 0,
      readOnly: window.FormEngine.engineConfig.startupReadOnly ? window.FormEngine.engineConfig.startupReadOnly : false,
    };
  },
  mounted() {
    window.FormEngine.form.registerApp(this);
  },
  methods: {
    reloadApp() {
      this.componentKey = this.componentKey + 1;
    },
  },
});
</script>
